<template>
  <v-card class="bookings matter-engagement-tab entity-list"  >

    <div class="booking-panels-wrapper" v-if="currContact">
      <ExpansionPanels
        class="bookings-panels"
        activeClass="active-bookings-view"
        :multiple="false"
        :disable-hover="false"
        :on-hover-color="hoverColor"
        @panel-change="whenPanelClicked"
        :items="bookingSections"
        :active-panels="['upcomingBookings']"
        :direction="direction">
        <template slot="content"
                  slot-scope="{item}">
          <div class="upcoming-panel"
               v-set-height="'booking-panels-wrapper'"
               v-if="item.id === 'upcomingBookings' && !refreshMarker[0]">
            <BookingList
              list-name="upcomingBookings"
              page="upcomingBookingsPage"
              set-page="setUpcomingPage"
              getter-completed="upcomingBookingsCompleted"
              load-data="loadUpcomingBookings"
              section="upcoming"
              :key="refreshId"
              :refreshId="refreshId"
              @click="navigateTo" />
          </div>
          <div class="past-panel"
               v-set-height="'booking-panels-wrapper'"
               v-if="item.id === 'pastBookings' && !refreshMarker[1]">
            <BookingList
              list-name="pastBookings"
              page="pastBookingsPage"
              set-page="setPastPage"
              getter-completed="pastBookingsCompleted"
              load-data="loadPastBookings"
              section="past"
              :key="refreshId"
              :refreshId="refreshId"
              @click="navigateTo" />
          </div>
        </template>
      </ExpansionPanels>
    </div>

    <FabBtn
      v-if="isMobile"
      :bgColor="brandBgColor"
      :textColor="brandTxtColor"
      custom-class="bottom-right"
      @click="handleMobileBtnClicks()"
      icon="icon-booking-plus" />

    <v-tooltip v-if="!isMobile"
               top
               content-class="fab-tooltip">
      <template v-slot:activator="{ on, attrs }">
        <span class="fab-btn bottom-right add-bookings-btn-desktop"
              v-bind="attrs"
              v-on="on">
          <DropdownMenu
            :top="true"
            :left="!isRightToLeft"
            :right="isRightToLeft"
            :offsetY="true"
            :items="bookingsActions"
            @item-clicked="actionsClicked">
            <v-btn :color="brandBgColor" rounded fab>
              <v-icon :color="brandTxtColor">icon-booking-plus</v-icon>
            </v-btn>
          </DropdownMenu>
        </span>
      </template>
      <span>
      {{$t('client.matters.matter_page.fabs.bookings')}}
      </span>
    </v-tooltip>

  </v-card>
</template>

<script>
import BookingList from "@/modules/matters/components/BookingList/BookingList"
import {setHeight} from "@/modules/matters/directives"
import {ExpansionPanels, DropdownMenu, FabBtn} from "@/modules/common/components"
import {mapGetters} from "vuex";
import matterActionsService from "@/modules/matters/services/matterActionsService";

export default {
  name: "Bookings",
  props: {
    matter: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ExpansionPanels,
    BookingList,
    FabBtn,
    DropdownMenu
  },
  directives: {
    'set-height': setHeight
  },
  data() {
    return {
      refreshId: 0,
      bookingSections: [
        {id:"upcomingBookings", name: this.$t('client.matters.matter_page.bookings_tab.upcoming_title'), trackingLabel: 'upcoming'},
        {id: 'pastBookings', name: this.$t('client.matters.matter_page.bookings_tab.past_title'), trackingLabel: 'past'}
      ],
      refreshMarker: [true, true],
      panelOpenIndex: -1,
    }
  },
  created() {
    this.$frontageApi.listen('fetch-bookings', this.onRefreshEvent.bind(this))
    this.whenPanelClicked(0, false)
    this.refresh()
  },
  computed: {
    ...mapGetters(['isRightToLeft', 'direction']),
    ...mapGetters("brandModule", ["hoverColor"]),
    currContact() {
      return this.$store.getters['mattersModule/currContact']
    },
    brandBgColor() {
      return this.$store.getters['brandModule/secondaryColor']
    },
    brandTxtColor() {
      return this.$store.getters['brandModule/textColor']
    },
    bookingsActions() {
      return matterActionsService.getActions('appointment', 'register_to_event')
    }
  },
  methods: {
    handleMobileBtnClicks() {
      this.$frontageApi.send('matter_action', {action: 'add_booking'});
    },
    actionsClicked(e) {
      this.$frontageApi.send('matter_action', {action: 'all_actions', action_name: e.action, origin: 'Bookings tab fab'});
    },
    navigateTo(booking) {
      if (booking.booking_type === 'event' || booking.booking_type === 'waitlist') {
        this.$frontageApi.navigateTo('app.event', {uid: booking.bookable_uid, origin: 'Client card booking tab'})
      } else {
        this.$frontageApi.navigateTo('app.appointment.show', {uid: booking.uid, origin: 'Client card booking tab'})
      }
    },
    handleBtnClick() {
      this.$frontageApi.send('matter_action', {action: 'add_appointment', origin: 'Booking tab fab'});
    },
    onRefreshEvent({clientUid}) {
      if (this.currContact.uid !== clientUid) return

      this.refresh()
    },
    async refresh() {
      this.$store.dispatch({type: "mattersModule/resetBookings"})
      this.refreshId++

      this.refreshMarker.forEach((item, i) => {
        if (this.panelOpenIndex !== i) {
          this.refreshMarker[i] = true
        }
      })
    },
    whenPanelClicked(index, track = true) {
      this.panelOpenIndex = index
      if (index === undefined || index === -1) {
        return
      }

      this.refreshMarker[index] = false
      track && this.$track(`Client card ${this.bookingSections[index].trackingLabel} booking panel`)
    }
  },
  destroyed() {
    this.$frontageApi.remove('fetch-bookings', this.onRefreshEvent)
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import '@/assets/scss/abstract/_i18n-mixins';

.bookings {
  position: relative;
  height: 100%;
  display: flex;

  .booking-panels-wrapper {
    flex: 1;
  }

  .upcoming-panel,
  .past-panel {
    display: flex;
  }

  .past-panel .booking-list {
    padding-bottom: 20px;
  }
  .add-bookings-btn-desktop {
    position: absolute;
  }
}
</style>
